import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/user-management',
    name: 'user-management',
    component: () => import('../pages/UserListPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
